// extracted by mini-css-extract-plugin
module.exports = {"altHero":"xe","altProd":"ye","subheading":"ze","subtext":"Ae","extrainfo":"Be","copy":"Ce","cta":"De","disabled":"Ee"};